import React from 'react';
import Accordion from '@/common/components/Accordion';

function Analyses({ items, header, onClick }) {
    if (!items || items.length === 0) {
        return null;
    }
    function navigate(e, item) {
        e.preventDefault();
        e.stopPropagation();
        onClick(item);
    }
    return (
        <div>
            <div className="header-section">{header}</div>
            {items.map(item => (
                <Accordion key={item.id} title={item.title} expanded>
                    <div className="search-analysis-text" onClick={e => navigate(e, item)}>
                        {item.annotation}
                    </div>
                </Accordion>
            ))}
        </div>
    );
}
export default Analyses;
